import React from "react";
import { cn } from "@src/lib/utils/cn";
import Text from "@src/lib/ui/Text";
import VideoFileImageIllustration from "@src/lib/illustrations/VideoFileImageIllustration";

interface ChatSidebarDragOverlayProps {
  isDragActive: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const ChatSidebarDragOverlay: React.FC<ChatSidebarDragOverlayProps> = ({
  isDragActive,
  className,
  style,
}) => {
  return (
    <div
      className={cn(
        "absolute inset-0 z-10 flex items-center justify-center transition-all duration-150 ease-in-out p-4",
        className,
      )}
      style={{
        backgroundColor: isDragActive
          ? "rgba(255, 255, 255, 0.8)"
          : "transparent",
        pointerEvents: "none",
        ...style,
      }}
    >
      <div
        className={cn(
          "flex flex-col items-center justify-center gap-2 transition-opacity duration-150 ease-in-out",
          isDragActive ? "opacity-100" : "opacity-0",
        )}
      >
        <VideoFileImageIllustration />
        <Text variant="compact-title" className="text-center text-foreground">
          Drop files to add to your conversation
        </Text>
      </div>
    </div>
  );
};
